import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, AppState } from "../../../store/configureStore";
import { getCurrentTenant } from "store/admin/tenantWideData";

const SettingsLandingPage = () => {
  const { t } = useTranslation("parts");
  const dispatch = useDispatch<AppDispatch>();
  const { isLoggedIn } = useSelector((state: AppState) => state.users.auth);
  const { data: currentTenant } = useSelector(
    (state: AppState) => state.admin.tenantWideData.currentTenant
  );

  useEffect(() => {
    if (isLoggedIn && !currentTenant) {
      dispatch(getCurrentTenant());
    }
  }, [isLoggedIn, currentTenant, dispatch]);

  const customerName = currentTenant?.Name;

  return (
    <>
      <div className="settings-card card">
        <div>{t("settings.currentCustomer")}: {customerName}</div>
      </div>
    </>
  );
};

export default SettingsLandingPage;
